export const calculateStep = (reservationCart) => {
  let step = 'customer';
  if (reservationCart.data) {
    if (
      step === 'customer' &&
      (reservationCart.data.email || reservationCart.data.customerId)
    ) {
      step = 'payment';
    }
    if (
      step === 'payment' &&
      reservationCart.data.billTo &&
      (reservationCart.data.creditCard ||
        reservationCart.data.virtualCart.total === 0)
    ) {
      step = 'complete';
    }
  }
  return step;
};

export const stepArray = ['customer', 'payment', 'complete'];

export const editStep = (reservationCart, step) => {
  const currentStep = calculateStep(reservationCart);
  const currentStepPosition = stepArray.indexOf(currentStep);
  const newStepPosition = stepArray.indexOf(step);
  if (currentStepPosition < newStepPosition) {
    return currentStep;
  }
  return step;
};

export const requiresCreditCard = (reservationCart) => {
  let showForm = true;
  if (reservationCart.virtualCart.total === 0) {
    showForm = false;
  }
  return showForm;
};
